// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_31JZCdt6O8d7kVk5jM4fjK","primary":"_2DkzRWw19J_FPOUhaHwEKq","dark":"bDFyCgEtiSltgniA31dpz"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/Pill.module.css
// module id = 2347
// module chunks = 1